
import {
  computed,
  defineComponent,
  ref,
  toRefs,
  watch,
} from 'vue';
import FileCaptionPair from '@/interface/FileCaptionPair';
import Post from '@/interface/Post';
import useMutationPostApi from '@/composables/useMutationPostApi';
import EnumColor from '@/enum/EnumColor';
import PostEditorAddPhotoArea from './PostEditorAddPhotoArea.vue';
import SvgIcon from '../SvgIcon.vue';

export default defineComponent({
  components: { PostEditorAddPhotoArea, SvgIcon },
  name: 'PostEditor',
  props: {
    isNewPost: {
      type: Boolean,
      required: true,
    },
    dateString: {
      type: String,
      required: true,
    },
    post: {
      type: Object as () => Post,
    },
    refetch: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const { isNewPost, dateString, post } = toRefs(props);
    const existingPost = ref({ ...props.post } as Post);

    watch(post, () => { existingPost.value = { ...props.post } as Post; });

    const newPost = ref({
      id: 0,
      title: '',
      from: dateString.value,
      to: dateString.value,
      color: EnumColor.LightBlue,
    } as Post);

    const editingPost = computed(() => {
      if (isNewPost.value) {
        return newPost.value;
      }
      if (existingPost.value) {
        return existingPost.value;
      }
      return newPost.value;
    });

    const pairsCollection = ref([] as FileCaptionPair[][]);

    const savePhotosToCollection = (photoAreaId: number, pairs: FileCaptionPair[]) => {
      // @ts-ignore
      pairsCollection.value[photoAreaId] = pairs;
    };

    const addPhotoArea = () => {
      const pairCollection = [] as FileCaptionPair[];
      pairsCollection.value.push(pairCollection);
    };

    const clearPhotoArea = () => {
      pairsCollection.value.splice(0, pairsCollection.value.length);
    };

    watch(editingPost, () => { clearPhotoArea(); });

    const {
      addPost,
      updatePost,
      addPostApiLoading,
      updatePostApiLoading,
    } = useMutationPostApi(pairsCollection, editingPost);

    const masked = ref(false);

    const saveAction = () => {
      masked.value = true;
      if (editingPost.value.title === '') {
        editingPost.value.title = dateString.value;
      }

      const save = isNewPost.value ? addPost : updatePost;
      save();
    };
    const loading = computed(() => isNewPost.value ? addPostApiLoading.value : updatePostApiLoading.value);

    watch(loading, (to, from) => {
      if (from && !to) { // from loading to not loading
        const closeBtn = document.getElementById('closeBtn');
        if (closeBtn) {
          closeBtn.click();
        }
        masked.value = false;
        props.refetch();
      }
    });

    return {
      editingPost,
      pairsCollection,
      addPhotoArea,
      savePhotosToCollection,
      saveAction,
      masked,
    };
  },
});
